import { create } from 'zustand';

interface LoadingState {
  loadingStates: Record<string, boolean>;
  optimisticUpdates: Record<string, unknown>;
  setLoading: (key: string, isLoading: boolean) => void;
  setOptimisticUpdate: (key: string, data: unknown) => void;
  clearOptimisticUpdate: (key: string) => void;
  clearAllOptimisticUpdates: () => void;
}

export const useLoadingStore = create<LoadingState>(set => ({
  loadingStates: {},
  optimisticUpdates: {},

  setLoading: (key, isLoading): void =>
    set(state => ({
      loadingStates: {
        ...state.loadingStates,
        [key]: isLoading,
      },
    })),

  setOptimisticUpdate: (key: string, data: unknown): void =>
    set(state => ({
      optimisticUpdates: {
        ...state.optimisticUpdates,
        [key]: data,
      },
    })),

  clearOptimisticUpdate: (key): void =>
    set(state => {
      // eslint-disable-next-line @typescript-eslint/no-unused-vars
      const { [key]: _, ...rest } = state.optimisticUpdates;
      return { optimisticUpdates: rest };
    }),

  clearAllOptimisticUpdates: (): void => set({ optimisticUpdates: {} }),
}));
